import { AGENT_ERROR_CODE } from '../ws/agent-ws.types';

/** Текст ошибки менеджера агента для UI. */
export interface AgentErrorMessage {
    title: string;
    text: string;
    /** Скрыть кнопку "назад" в заголовке чата. */
    hideBackButton?: boolean;
}

/**
 * Кастомные сообщения по коду ошибки протокола агента.
 */
export const AGENT_ERROR_MESSAGES: Record<string, AgentErrorMessage> = {
    [AGENT_ERROR_CODE.sessionLocked]: {
        title: 'Диалог открыт в другой вкладке',
        text: 'Закройте его там, чтобы продолжить работу здесь.',
    },
    [AGENT_ERROR_CODE.sessionTakenOver]: {
        title: 'Диалог открыт в другом окне',
        text: 'Работа с диалогом продолжается там. Откройте его здесь заново, когда закончите.',
    },
    [AGENT_ERROR_CODE.configMismatch]: {
        title: 'ИИ агент обновляется',
        text: 'Подождите несколько минут и переоткройте страницу',
        hideBackButton: true,
    },
};

/**
 * Вернуть кастомное сообщение по коду или fallback.
 */
export function resolveAgentErrorMessage(
    code: string | undefined | null,
    fallback: AgentErrorMessage,
): AgentErrorMessage {
    if (!code) {
        return fallback;
    }

    return AGENT_ERROR_MESSAGES[code] ?? fallback;
}
